import axios from "axios";

export interface GetOrderStatusResponse {
  OrderNum: number;
  OrderDate: string;
  ExpectDate: string;
  StatusCode: string;
  OrderType: "E" | "S";
}

export const getProviderSlotRequest = async (
  officeId: string
): Promise<any> => {
  try {
    const { data } = await axios.get<any>(
      `/api/v2/provider_slots?office_id=${officeId}`
    );
    return data.provider_slots;
    /*
    return data.order_tracking_info.map((pref) => ({
      orderNum: pref.order_num,
      orderDate: pref.order_date,
      orderTypeName: pref.order_type_name,
      expectDate: pref.expect_date,
      fulfillmentType: pref.fulfillment_type,
      fulfillmentDestination: pref.fulfillment_destination,
      displayByline: pref.display_byline,
      displayStatus: pref.display_status,
    })); */
  } catch (err) {
    return [];
  }
};
